const serviceMedia = [
  {
    slug: 'regular-cleaning',
    images: [
      '/assets/58123.jpg',
      '/assets/80d7b81882_1.jpg'
    ]
  },
  {
    slug: 'general-cleaning',
    images: [
      '/assets/still-life-office-cleaning-process-23-2149343067.jpg',
      '/assets/still-life-office-cleaning-process-23-2149343074.jpg'
    ]
  },
  {
    slug: 'deep-cleaning',
    images: [
      '/assets/still-life-office-cleaning-process_23-2149343067.jpg',
      '/assets/what-is-included-in-a-deep-house-cleaning.jpg',
      '/assets/2150520640.jpg'
    ]
  },
  {
    slug: 'post-construction-cleaning',
    images: ['/assets/1210.jpg']
  },
  {
    slug: 'move-in-move-out',
    images: ['/assets/photo-1582719478250-c89cae4dc85b.jpg']
  },
  {
    slug: 'office-cleaning',
    images: ['/assets/photo-1524758631624-e2822e304c36.jpg']
  },
  {
    slug: 'commercial-cleaning',
    images: ['/assets/photo-1441986300917-64674bd600d8.jpg']
  },
  {
    slug: 'window-cleaning',
    images: [
      '/assets/17937.jpg',
      '/assets/2148705065.jpg',
      '/assets/2149374387.jpg'
    ]
  },
  {
    slug: 'carpet-upholstery-cleaning',
    images: [
      '/assets/professional-cleaning-service-person-using-steam-cleaner-office-23-2150520644.png'
    ]
  }
];

export default serviceMedia;
